
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    SEND_COMMAND_GET_DEVICE_REQUEST,
    SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST,
    SEND_COMMAND_SEARCH_COMMANDS_REQUEST,
    SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST,
    SEND_COMMAND_REQUEST,
    SEND_COMMAND_GET_DETAILS_REQUEST,
    SEND_COMMAND_GENERAL_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    sendCommandGetDeviceResult,
    sendCommandSearchDeviceModelResult,
    sendCommandSearchCommandsResult,
    sendCommandSearchMassCommandsResult,
    sendCommandResult,
    sendCommandGetDetailsResult,
} from 'Redux/actions';

const EMPTY_GROUPED_COMMANDS = {
    manufacturer: null,
    unitTypes: [],
    deviceModels: [],
};


function* getDevice({ payload }) {
    try {
        const QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        simCard {
                            iccId
                            msisdn
                            simProviderAccount {
                                id
                                name
                                simProviderId
                                simProvider {
                                    id
                                    name
                                }
                            }
                        }
                        deviceModel {
                            id
                            unitTypeId
                            unitType {
                                id
                                name
                                manufacturerId
                                manufacturer {
                                    id
                                    name
                                }
                                dbSchema
                                active
                            }
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                    }
                    total 
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(sendCommandGetDeviceResult(data?.result))
        } else {
            yield put(sendCommandGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(sendCommandGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/sendCommand/redux/saga",
            "getDevice"
        )
    }
}

function* searchDeviceModelForId({ payload }) {
    try {

        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        deviceModel {
                            id
                            unitTypeId
                            unitType {
                                id
                                name
                                manufacturerId
                                manufacturer {
                                    id
                                    name
                                }
                                dbSchema
                                active
                            }
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["id"],
                    terms: payload,
                    exact: true
                },
                limit: 100,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(sendCommandSearchDeviceModelResult(data?.result))
        }

    } catch (exc) {
        yield put(sendCommandSearchDeviceModelResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/sendCommand/redux/saga",
            "searchDeviceModelForId"
        )
    }
}

function* searchCommands({ payload }) {
    try {
        let QUERY = `
            query searchCannedCommands ($conditions: [CannedCommandSearchInput], $sort: [CannedCommandSortInput], $limit: Int, $offset: Int) {
                result: searchCannedCommands (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        unitTypeId
                        unitType {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                            dbSchema
                            active
                        }
                        via
                        label
                        command
                        status
                        appliesToAllUnitTypes
                    }
                    total
                }
            }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["manufacturerId"],
                        terms: [payload.manufacturerId],
                        exact: true
                    },
                    {
                        fields: ["via"],
                        terms: [payload.via],
                        exact: true
                    }
                ],
                limit: 600,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let realItems = [];
            const { items } = data.result;
            realItems = items.filter(x => x.unitTypeId === payload.unitTypeId || x.appliesToAllUnitTypes)
            yield put(sendCommandSearchCommandsResult(realItems))
        } else {
            yield put(sendCommandSearchCommandsResult([]))
        }
    } catch (exc) {
        yield put(sendCommandSearchCommandsResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/sendCommand/redux/saga",
            "searchCommands"
        )
    }
}

function* searchMassCommands({ payload }) {
    try {
        const unitTypeIds = Array.isArray(payload?.unitTypeIds) ? payload.unitTypeIds : [];
        const deviceModelIds = Array.isArray(payload?.deviceModelIds) ? payload.deviceModelIds : [];

        if (!payload?.manufacturerId) {
            yield put(sendCommandSearchMassCommandsResult(EMPTY_GROUPED_COMMANDS))
            return;
        }

        let QUERY = `
            query searchCannedCommands ($conditions: [CannedCommandSearchInput], $sort: [CannedCommandSortInput], $limit: Int, $offset: Int) {
                result: searchCannedCommands (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        unitTypeId
                        unitType {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                        deviceModelId
                        deviceModel {
                            id
                            name
                            unitTypeId
                        }
                        via
                        label
                        command
                        status
                        appliesToAllUnitTypes
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["manufacturerId"],
                        terms: [payload.manufacturerId],
                        exact: true,
                    },
                    {
                        fields: ["via"],
                        terms: ["SMS"],
                        exact: true,
                    }
                ],
                limit: 1000,
                offset: 0,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        const items = data?.result?.items || [];
        const activeItems = items.filter((item) => item?.status !== 'Inactive');

        const manufacturerCommands = activeItems.filter((item) => item?.appliesToAllUnitTypes && !item?.deviceModelId);
        const groupedUnitTypes = unitTypeIds.map((unitTypeId) => {
            const entityItems = activeItems.filter((item) => item?.unitTypeId === unitTypeId && !item?.deviceModelId);
            if (entityItems.length === 0) return null;

            return {
                id: unitTypeId,
                name: entityItems[0]?.unitType?.name || `${unitTypeId}`,
                cannedCommands: entityItems,
            };
        }).filter(Boolean);

        const groupedDeviceModels = deviceModelIds.map((deviceModelId) => {
            const entityItems = activeItems.filter((item) => item?.deviceModelId === deviceModelId);
            if (entityItems.length === 0) return null;

            return {
                id: deviceModelId,
                name: entityItems[0]?.deviceModel?.name || `${deviceModelId}`,
                cannedCommands: entityItems,
            };
        }).filter(Boolean);

        yield put(sendCommandSearchMassCommandsResult({
            manufacturer: manufacturerCommands.length > 0
                ? {
                    id: payload.manufacturerId,
                    cannedCommands: manufacturerCommands,
                }
                : null,
            unitTypes: groupedUnitTypes,
            deviceModels: groupedDeviceModels,
        }))
    } catch (exc) {
        yield put(sendCommandSearchMassCommandsResult(EMPTY_GROUPED_COMMANDS))
        ExceptionManager(
            exc,
            "Modules/devices/.components/sendCommand/redux/saga",
            "searchMassCommands"
        )
    }
}

function* createNotificationUsingTransaction({ payload }) {
    try {

        let QUERY = `
            mutation createNotificationUsingTransaction ($email: emailNotificationInput, $sms: String, $command: String, $to: [toEntityInput]!, $emailRecipients: [String]) {
                result: createNotificationUsingTransaction (email: $email, sms: $sms, command: $command, to: $to, emailRecipients: $emailRecipients){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(sendCommandResult(data?.result))
        } else {
            yield put(sendCommandResult({ error: true }))
        }

    } catch (exc) {
        yield put(sendCommandResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/sendCommand/redux/saga",
            "createNotificationUsingTransaction"
        )
    }
}

function* createNotification({ payload }) {
    try {

        let QUERY = `
            mutation createNotification ($email: emailNotificationInput, $sms: String, $command: String, $to: [toEntityInput]!, $emailRecipients: [String], $projectId: String) {
                result: createNotification (email: $email, sms: $sms, command: $command, to: $to, emailRecipients: $emailRecipients, projectId: $projectId)
            }
        `;
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(sendCommandResult(data?.result))
        } else {
            yield put(sendCommandResult({ error: true }))
        }

    } catch (exc) {
        yield put(sendCommandResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/sendCommand/redux/saga",
            "createNotification"
        )
    }
}

function* getSMSDetails({ payload }) {

    try {
        const { type, entities } = payload;

        let QUERY = `
            query getSMSDetails ($type: enumSimSearchType!, $entities: [String]!) {
                result: getSMSDetails (type: $type, entities: $entities) {
                        items {
                            unitId
                            companyId
                            iccid
                            msisdn
                            in
                            out
                        }
                    }
                }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            {
                type: type,
                entities: entities
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(sendCommandGetDetailsResult(data?.result?.items || []))
        } else {
            yield put(sendCommandGetDetailsResult(null))
        }
    } catch (exc) {
        yield put(sendCommandGetDetailsResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/sendCommand/redux/saga",
            "getSMSDetails"
        )
    }
}

function* watchMethods() {
    yield takeEvery(SEND_COMMAND_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST, searchDeviceModelForId);
    yield takeEvery(SEND_COMMAND_SEARCH_COMMANDS_REQUEST, searchCommands);
    yield takeEvery(SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST, searchMassCommands);
    yield takeEvery(SEND_COMMAND_REQUEST, createNotificationUsingTransaction);
    yield takeEvery(SEND_COMMAND_GET_DETAILS_REQUEST, getSMSDetails);
    yield takeEvery(SEND_COMMAND_GENERAL_REQUEST, createNotification);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}